import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { UzurvRestService } from '@uzurv/rideWss/http';
import { isNullOrUndefined } from '@uzurv/rideWss/app/util';
import { UserNotFoundException } from '@uzurv/rideWss/auth';

@Injectable({
  providedIn: 'root'
})
export class PasswordService extends UzurvRestService {
  constructor() {
    super();
  }

  /**
   * Requests a password reset interaction for the given user
   *
   * @param username
   */
  forgotPassword(username: string): Observable<boolean> {
    return this.get('resetPassword/requestReset', { username: username })
      .pipe(map(() => true))
      .pipe(
        catchError(err => {
          const message = isNullOrUndefined(err.message) ? '' : err.message;

          if (message.includes('User with username') && message.includes('not found')) {
            return throwError(() => new UserNotFoundException(message));
          }

          return throwError(() => err);
        })
      );
  }

  /**
   * Validates the given password
   *
   * @param password
   */
  validatePassword(password: string): Observable<boolean> {
    return this.get('validatePassword', { password: password }).pipe(map(() => true));
  }
}
